module.exports = __webpack_public_path__ + "img/about-banner-md.f372f6b5.jpeg";